import React from 'react'
import styles from './styles.module.css'
import { ChatThinking } from '../ChatActivity'

interface Props extends React.HTMLAttributes<HTMLElement> {
  user?: boolean
  thinking?: boolean
  attachment?: React.ReactNode
  meta?: React.ReactNode
}
export const ChatMessage: React.FC<Props> = ({ user, thinking, attachment, meta, children, ...props }) => (
  <article {...props} className={[styles.message, user ? styles.user : styles.assistant].join(' ')}>
    {user ? (
      <>
        {attachment && <div className={styles.userAttachment}>{attachment}</div>}
        {children && (
          <div className={styles.userBubble}>
            <div className={styles.userText} dir="auto">
              {children}
            </div>
          </div>
        )}
        {meta && <div className={styles.meta}>{meta}</div>}
      </>
    ) : (
      <>
        {thinking && <ChatThinking />}
        <div className={styles.messageBody}>
          {children}
          {meta && <div className={styles.meta}>{meta}</div>}
        </div>
      </>
    )}
  </article>
)
